<template>
  <v-menu v-model="open" offset-y :close-on-content-click="false">
    <template #activator="activator">
      <slot name="activator" v-bind="activator"></slot>
    </template>
    <div class="mx-auto p-modal" outlined>
      <v-card-text class="p-card-text">
        <v-row style='max-width: 400px'>
          <v-checkbox
            class="col-auto p-checkbox"
            v-for="(site, index) in sites"
            :key="`select_site_${index}`"
            :label="site.name"
            :value="selected(site)"
            @change="(event) => changeSelectSite(event, site)"
          />
        </v-row>
      </v-card-text>
    </div>
    <div class="p-btn-wrap">
      <v-btn @click="cancel" text> キャンセル</v-btn>
      <v-btn color="primary" @click="complete" text> 決定</v-btn>
    </div>
  </v-menu>
</template>

<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import Qs from 'qs'

export default {
  name: 'SelectSiteListContainer',
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      open: false,
      sites: [],
      selectedSites: []
    }
  },
  mounted () {
    this.fetchSites()
  },
  methods: {
    fetchSites () {
      axios
        .get(`/api/master/sites`, {
          params: { q: { select_has_user_auth: true } },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then((data) => {
          this.sites = deserialize(data.data).data
        })
    },
    cancel () {
      this.open = false
    },
    complete () {
      this.open = false
      this.$emit('input', [...this.selectedSites.map((site) => ({ ...site }))])
    },
    changeSelectSite (checked, site) {
      checked ? this.selectSite(site) : this.removeSite(site)
    },
    selectSite (site) {
      this.selectedSites.push(site)
    },
    removeSite (site) {
      const index = this.selectedSites.findIndex(
        (selectSite) => selectSite.siteKey === site.siteKey
      )
      this.selectedSites.splice(index, 1)
    },
    selected (site) {
      return (
        this.selectedSites.findIndex(
          (selectSite) => selectSite.siteKey === site.siteKey
        ) !== -1
      )
    }
  }
}
</script>

<style scoped>
.p-modal {
  max-height: 500px;
  overflow: scroll;
  background-color: white;
}
.p-card-text {
  padding-bottom: 0;
}
.p-checkbox {
  margin-top: 0;
  padding-top: 0;
  padding-bottom: 0;
  width: 100%;
  font-size: 12px;
}
.p-btn-wrap {
  height: 50px;
  padding: 8px 8px 0 210px;
  background-color: white;
}

</style>
